<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter8">
<h1><a id="page_26"></a><a href="#/003toc#ch8">Creamy Onion Soup</a></h1>
<p class="noindent">When I was a teenager, I watched Julia Child prepare French onion soup on her TV program, and I was never the same. Although I grew up in an Italian home where there was never store-bought bread or canned soup, Julia brought French food into my life and I have been hooked ever since. Chances are the French onion soup you have had is a poor imitation of the real McCoy. This slow-cooker method delivers a creamier soup with lots of onions that melt during the cooking process. I recommend using a soup base or demi-glace to get full flavor, but you can still use beef broth if you prefer.</p>
<p class="noindent">½ cup (1 stick) unsalted butter</p>
<p class="noindent">2 tablespoons olive oil</p>
<p class="noindent">5 large sweet onions, such as Vidalia, thinly sliced</p>
<p class="noindent">2 tablespoons sugar</p>
<p class="noindent">1 tablespoons dried thyme</p>
<p class="noindent">1 teaspoon salt</p>
<p class="noindent">½ teaspoon freshly ground black pepper</p>
<p class="noindent">1 bay leaf</p>
<p class="noindent">½ cup white wine (see savvy)</p>
<p class="noindent">5 cups beef stock (see savvy)</p>
<p class="noindent">1½ cups finely shredded Gruyère cheese for garnishing</p>
<p class="noindent">turn a 5- to 7-quart slow cooker on high, add the butter and oil to the insert, cover until the butter is melted.</p>
<p class="noindent">remove the cover and add the onions, sugar, thyme, salt, pepper, and bay leaf. Stir the onions until they are coated with the butter and seasonings.</p>
<p class="noindent">cover and cook on high for 7 to 8 hours, until they are caramelized to a deep golden brown.</p>
<p class="noindent">remove the cover and add the wine and beef stock. Cover and cook the soup on high for an additional 30 minutes or on low for an additional 1 hour.</p>
<p class="noindent">remove the bay leaf before serving and garnish each serving with a sprinkling of Gruyère cheese.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> white wine savvy</p>
<p class="noindent">One of Julia’s tricks was to use white vermouth if you don’t have any leftover white wine. It makes a good substitute and keeps in the pantry for months.</p>
<p class="noindent"><strong>beef stock savvy</strong></p>
<p class="noindent">I recommend Superior Touch “Better than Bouillon” brand soup base (available in supermarkets or at www.superiortouch.com) or reconstituted “More than Gourmet” brand Glace de Viande Gold, which is a classic reduced brown stock (available in gourmet stores or at <a href="http://www.morethangourmet.com" target="_blank">www.morethangourmet.com</a>.)</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 014-chapter8.vue?22108a0c